module.exports = __webpack_public_path__ + "static/media/person-detail.bd184465.svg";